module.exports = __webpack_public_path__ + "static/media/KW900-01-14.2cc03b11.JPG";